{
	"title": "Mission Control",
	"band": {
		"label": "Games progress",
		"liveNow_one": "{{n}} meet live now",
		"liveNow_other": "{{n}} meets live now",
		"nothingLive": "Nothing live right now",
		"share": "({{percent}} of the games done)"
	},
	"ribbon": {
		"label": "Alerts",
		"clear": "All clear. No meet is past its limit.",
		"loading": "Checking for alerts…",
		"error": "The alerts could not load.",
		"since": "since {{time}}",
		"kind": {
			"unofficial_overdue_one": "{{n}} {{sport}} meet unofficial over {{minutes}} min",
			"unofficial_overdue_other": "{{n}} {{sport}} meets unofficial over {{minutes}} min",
			"live_overrun_one": "{{n}} {{sport}} meet live {{minutes}} min past its end",
			"live_overrun_other": "{{n}} {{sport}} meets live {{minutes}} min past their end",
			"late_start_one": "{{n}} {{sport}} meet not started {{minutes}} min after its start",
			"late_start_other": "{{n}} {{sport}} meets not started {{minutes}} min after their start",
			"interrupted_one": "{{n}} {{sport}} meet interrupted",
			"interrupted_other": "{{n}} {{sport}} meets interrupted"
		},
		"title": "Needs attention now",
		"inspect": "Inspect",
		"jump": "Jump to match",
		"jumpLabel": "Open meet: {{text}}",
		"jumpHint_one": "Opens the meet.",
		"jumpHint_other": "Opens the one waiting longest.",
		"showAll_one": "Show {{n}} more alert",
		"showAll_other": "Show {{n}} more alerts",
		"showFewer": "Show fewer",
		"inspectLabel": "Inspect: {{text}}"
	},
	"alertShort": {
		"unofficial_overdue": "Waiting over {{minutes}} min",
		"live_overrun": "Past its end",
		"late_start": "Not started",
		"interrupted": "Interrupted"
	},
	"board": {
		"title": "Venues",
		"subtitle": "Every venue's sports, with what needs attention. Courts and fields count in their hall.",
		"today": "Today",
		"wholeGames": "Whole games",
		"rangeLabel": "Show meets for",
		"sport": "Sport",
		"emptyToday": "No meets are scheduled today.",
		"empty": "No meets in this games yet.",
		"noVenue": "No venue yet",
		"venueStats_one": "{{n}} meet",
		"venueStats_other": "{{n}} meets",
		"live": "Live",
		"unofficial": "Unofficial",
		"startList": "Start list",
		"onHold": "On hold",
		"official": "Official",
		"officialOf": "{{official}} / {{total}}",
		"next": "Next {{time}}",
		"inspect": "Inspect",
		"inspectLabel": "Inspect {{sport}} at {{venue}}",
		"alerts_one": "{{n}} alert",
		"alerts_other": "{{n}} alerts",
		"previous": "Previous",
		"nextPage": "Next",
		"page": "Page {{page}} of {{pages}}"
	},
	"operators": {
		"summary": "{{active}} of {{assigned}} operators active",
		"none": "No operator assigned",
		"hint": "Operators whose group holds this sport and may enter results. Active means signed in and seen in the last 20 minutes."
	},
	"inspector": {
		"label": "Inspector",
		"close": "Close the inspector",
		"allVenues": "Every venue",
		"scopeDay": "{{day}}",
		"scopeAll": "Whole games",
		"scopeAlert": "Meets that can raise this alert, every day",
		"empty": "No meets to show.",
		"loadMore": "Show more",
		"open": "Open",
		"openLabel": "Open meet {{meet}}",
		"history": "History",
		"hideHistory": "Hide history",
		"makeOfficial": "Make official",
		"since": "{{status}} since {{time}}",
		"confirm": {
			"title": "Make meet {{meet}} official?",
			"body": "The result becomes final and fills every slot that waits on it, as from the meet's own screen. You are not at the scoring desk: check the result first if you have not.",
			"reason": "Why are you making it official from here?",
			"placeholder": "e.g. Referee confirmed by radio, operator offline",
			"confirm": "Make official"
		},
		"done": "Meet {{meet}} is official."
	},
	"activity": {
		"title": "Activity log",
		"subtitle": "Every write to a meet, newest first.",
		"empty": "Nothing written yet.",
		"older": "Show older",
		"by": "by {{who}}",
		"meet": "Meet {{meet}}",
		"slots_one": "{{n}} entry",
		"slots_other": "{{n}} entries",
		"actorType": {
			"USER": "a user",
			"AI_AGENT": "an AI agent",
			"SYSTEM": "the system",
			"MIGRATION": "a data load"
		},
		"kind": {
			"deleted": "Meet deleted",
			"created": "Meet created",
			"official": "Made official",
			"reopened": "Reopened",
			"status": "Status changed",
			"results": "Results entered",
			"start_list": "Start list changed",
			"officials": "Officials changed",
			"edited": "Details changed"
		},
		"to": "to"
	},
	"errors": {
		"boardTitle": "The venue board could not load",
		"retry": "Try again"
	},
	"header": {
		"during": "{{games}}, Day {{day}} of {{of}}. {{date}}",
		"before": "{{games}} starts on {{first}}. Today is {{date}}",
		"after": "{{games}} ended on {{last}}. Today is {{date}}",
		"unknown": "{{games}}. Today is {{date}}"
	}
}
